export default "__VITE_ASSET__UcYWlFeL__"